export const CHANGE_PERIOD = "CHANGE_PERIOD";
export const CLEAR_PERIOD = "CLEAR_PERIOD";
